import React from 'react';
import { useTranslation } from 'react-i18next';

import { convertRemToPixels } from '@/common/lib/convertRemtoPx';
import { toShortNumFormat } from '@/common/lib/toShortNumFormat';
import { H1, H2 } from '@/components/Typography/Typography';
import { useAppSelector } from '@/redux/store';

import airdropFriendsPng from '/img/airdrop/airdrop_friends.png';
import airdropFriendsWebp from '/img/airdrop/airdrop_friends.webp';
import BadgePng from '/img/airdrop/badge.png';
import BadgeWebp from '/img/airdrop/badge.webp';
import badgeLines from '/img/airdrop/badge_lines.png';
import StarPng from '/img/airdrop/Star.png';
import StarWebp from '/img/airdrop/Star.webp';
import starPoints from '/img/airdrop/stars_point.svg';
import TCoinPng from '/img/airdrop/t-coin.png';
import TCoinpWebp from '/img/airdrop/t-coin.webp';
import tgemCircle from '/img/airdrop/tgem_circle.svg';

const AirdropBody: React.FC = () => {
  const { t } = useTranslation();
  const airdrop = useAppSelector((state) => state.user.airdrop);

  return (
    <div className="airdrop_body">
      <div className="airdrop_title">
        <H1>{t('Performance')}</H1>
        <p>{t('Your in-game activity holds special value.')}</p>
      </div>
      <ul className="airdrop_list">
        <li className="green-radial-gradient">
          <div className="airdrop_list_card_background">
            <img src={starPoints} alt="onboarding" />
            <div className="main-img">
              <picture>
                <source srcSet={StarWebp} type="image/webp" />
                <img src={StarPng} alt="onboarding" width={104} />
              </picture>
            </div>
          </div>
          <div className="airdrop_list_card_info">
            <div>
              <H2>{t('Star Points')}</H2>
              <span>{toShortNumFormat(airdrop?.totalPointsEarn ?? 0)}</span>
            </div>
            <p>
              {t(
                'Collect Star Points and level up to unlock new opportunities!',
              )}
            </p>
          </div>
        </li>
        <li className="purple-radial-gradient">
          <div className="airdrop_list_card_background">
            <img src={tgemCircle} alt="onboarding" />
            <div className="main-img">
              <picture>
                <source srcSet={TCoinpWebp} type="image/webp" />
                <img src={TCoinPng} alt="onboarding" width={104} />
              </picture>
            </div>
          </div>
          <div className="airdrop_list_card_info">
            <div>
              <H2>{t('T-Gems spent')}</H2>
              <span>{airdrop?.totalSpentTgems ?? 0}</span>
            </div>
            <p>
              {t(
                'Spend your earned and purchased T-GEM to accelerate your progress!',
              )}
            </p>
          </div>
          <div className="gradient-1"></div>
          <div className="gradient-2"></div>
          <div className="gradient-3"></div>
        </li>
        <li className="light-green-gradient">
          <div className="airdrop_list_card_background">
            <picture>
              <source srcSet={airdropFriendsWebp} type="image/webp" />
              <img
                src={airdropFriendsPng}
                alt="onboarding"
                width={convertRemToPixels(17.0625)}
              />
            </picture>
          </div>
          <div className="airdrop_list_card_info">
            <div>
              <H2>{t('Invited friends')}</H2>
              <span>{toShortNumFormat(airdrop?.invitedFriendsCount ?? 0)}</span>
            </div>
            <p>
              {t('Friends who have reached level 5 are taken into account')}
            </p>
          </div>
        </li>
        <li className="light-red-gradient">
          <div className="airdrop_list_card_background">
            <img src={badgeLines} alt="onboarding" />
            <div className="main-img">
              <picture>
                <source srcSet={BadgeWebp} type="image/webp" />
                <img src={BadgePng} alt="onboarding" width={150} />
              </picture>
            </div>
          </div>
          <div className="airdrop_list_card_info">
            <div>
              <H2>{t('Arena Score')}</H2>
              <span>{toShortNumFormat(airdrop?.totalLeaguePoints ?? 0)}</span>
            </div>
            <p>
              {t(
                'Rating points are awarded for activity in weekly competitions.',
              )}
            </p>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default AirdropBody;
